import { COLORS } from "./Colors";


export function injectThemeVariables() {
  const root = document.documentElement;

  Object.entries(COLORS).forEach(([key, value]) => {
    if (typeof value === "string") {
      root.style.setProperty(`--${key.toLowerCase()}`, value);
    } else {
      Object.entries(value).forEach(([subKey, subValue]) => {
        root.style.setProperty(`--${key.toLowerCase()}-${subKey.toLowerCase()}`, subValue);
      });
    }
  });
}
